import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { NoteAddIcon as AddIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type GridExpressProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const CreateButton: React.FC<GridExpressProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore } = rootStore;

    return (
      <Button
        // sx={{
        //     color: theme.palette.primary.contrastText, textTransform: "none",
        //     paddingRight: 0,
        //     paddingLeft: 3
        // }}
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<AddIcon />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {label === undefined ? "Crear uno nuevo" : label}
      </Button>
    );
  }
);
